import React, { ReactNode } from 'react';

import classes from './ReleaseNotesModal.module.scss';
import { LbModal } from '../../../../../shared/components/modals';
import { ScrollBox } from '../../../../../shared/components/ui-components';

type ReleaseNotesModalProps = {
  notes: ReactNode;
  onClose: () => void;
};

const ReleaseNotesModal = ({ notes, onClose }: ReleaseNotesModalProps) => {
  return (
    <LbModal
      open
      title="Release Notes"
      text="Full release description"
      onClose={onClose}
      primaryBtnConfig={{ onClick: onClose, text: 'Close' }}
    >
      <ScrollBox maxHeight={300} variant="outBox">
        <div className={classes.notesBox}>{notes}</div>
      </ScrollBox>
    </LbModal>
  );
};

export { ReleaseNotesModal };
